import { useTranslation } from 'react-i18next';
import { FaDownload, FaEdit, FaEye } from 'react-icons/fa';
import { useFileDownload } from 'hooks';
import { MenuOption } from 'types';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { ConsultationDocument } from 'api';

export const usePlansMenuOptions = (): MenuOption[] => {
  const { t } = useTranslation('case_details_plans');
  const measurementTool = useFeatureValue('disable_consultee_measurement_tool', false);
  const { downloadConsultationDocument, openConsultationDocument, openMeasuringTool } =
    useFileDownload();

  const menuOptions = [
    {
      label: t('view_button', 'View'),
      icon: FaEye,
      onClick: (
        consultation: number | undefined,
        document: ConsultationDocument | undefined
      ) => openConsultationDocument(document),
    },
    {
      label: t('download_button', 'Download copy'),
      icon: FaDownload,
      onClick: (
        consultation: number | undefined,
        document: ConsultationDocument | undefined
      ) => downloadConsultationDocument(document),
    },
  ];

  if (!measurementTool) {
    const measuringToolOption = {
      label: t('measuring_tool_button', 'Measuring tool'),
      icon: FaEdit,
      onClick: (
        consultation: number | undefined,
        document: ConsultationDocument | undefined
      ) => openMeasuringTool(consultation, document),
    };
    menuOptions.splice(1, 0, measuringToolOption);
  }

  return menuOptions;
};
